// import React, { useState, useEffect } from "react";
// import {
// 	Table,
// 	TableBody,
// 	TableCell,
// 	TableHead,
// 	TableHeader,
// 	TableRow,
// } from "../components/ui/table";
// import { useNavigate } from "react-router-dom";
// import { useToast } from "../components/ui/use-toast";
// import { ClipLoader } from "react-spinners";
// import {
// 	Dialog,
// 	DialogContent,
// 	DialogDescription,
// 	DialogHeader,
// } from "../components/ui/dialog";
// import {
// 	Select,
// 	SelectContent,
// 	SelectItem,
// 	SelectTrigger,
// 	SelectValue,
// } from "../components/ui/select";
// import ProductForm from "../components/ProductForm";
// import { AiOutlineEdit } from "react-icons/ai";
// import useAuth from "../hooks/useAuth";
// import { useCheckClientProducts, useGetAllClients, useGetClientProducts } from "../migration-api/api-hooks/clients";

// function ClientProducts() {
// 	const [open, setOpen] = useState(false);
// 	const navigate = useNavigate();
// 	const { auth } = useAuth();
// 	const { toast } = useToast();

// 	const [clientProducts, setClientProducts] = useState([]);
// 	const [localProduct, setLocalProduct] = useState(null);
// 	const [selectedClientEmail, setSelectedClientEmail] = useState("");

// 	const isSuperAdmin = auth?.user?.role === "SUPER_ADMIN";
//   	const isAdmin = auth?.user?.role !== "SUPER_ADMIN";
// 	const clientId = auth?.user?.clientId;


// 	// Fetch all clients for super admin
// 	const { data: clientsData, isLoading: isLoadingClients } = useGetAllClients({
// 		enabled: isSuperAdmin,
// 		onError: (error) => {
// 			toast({
// 				variant: "destructive",
// 				title: "Error",
// 				description: "Failed to fetch clients",
// 			});
// 		},
// 	});

// 	// Use the custom hook for checking client products
// 	const { checkClientProducts, isLoading: isLoadingProducts } = useGetClientProducts(clientId, {
//       	enabled: isAdmin && !!clientId,
// 		onSuccess: (data) => {
// 			const products = data?.data?.products || [];
// 			setClientProducts(products);

// 			if (products.length === 0) {
// 				toast({
// 					title: "No Products Found",
// 					description: "This client has no products available.",
// 				});
// 			}
// 		},
// 		onError: (error) => {
// 			// Clear the products when error occurs
// 			setClientProducts([]);

// 			if (error.code === "ERR_NETWORK") {
// 				navigate("/", { replace: true });
// 			} else if (
// 				error.response?.status === 401 ||
// 				error.response?.status === 403
// 			) {
// 				navigate("/", { replace: true });
// 			} else {
// 				toast({
// 					variant: "destructive",
// 					title: "Error",
// 					description:
// 						error?.response?.data?.message || "Failed to fetch products",
// 				});
// 			}
// 		},
// 	});

// 	// Auto-select first client for SUPER_ADMIN when clients are loaded
// 	useEffect(() => {
// 		const clients = clientsData?.data || [];
// 		if (isSuperAdmin && clients.length > 0 && !selectedClientEmail) {
// 			const firstClient = clients[0];
// 			setSelectedClientEmail(firstClient.email);
// 			checkClientProducts({ client_email: firstClient.email });
// 		}
// 	}, [isSuperAdmin, clientsData, selectedClientEmail]);

// 	// Fetch products on component mount for ADMIN users
// 	useEffect(() => {
// 		if (isAdmin && auth?.user?.email) {
// 			checkClientProducts({ client_email: auth.user.email });
// 		}
// 	}, [isAdmin, auth?.user?.email]);

// 	// Handle client selection for SUPER_ADMIN
// 	const handleClientSelect = (clientEmail) => {
// 		setSelectedClientEmail(clientEmail);
// 		setClientProducts([]); // Clear previous products
// 		checkClientProducts({ client_email: clientEmail });
// 	};

// 	// Handle opening edit dialog
// 	const handleOpen = (productData) => {
// 		setOpen(true);
// 		const clientEmail = isSuperAdmin ? selectedClientEmail : auth?.user?.email;
		
// 		setLocalProduct({
// 			...productData,
// 			client_email: clientEmail,
// 			description: productData?.description,
// 			prod_name: productData?.prod_name,
// 			gtin: productData?.gtin,
// 			nafdac_reg_no: productData?.nafdac_reg_no,
// 			is_nafdac: productData?.is_nafdac,
// 		});
// 	};

// 	// Refresh products after update
// 	const handleComplete = () => {
// 		setOpen(false);
// 		const clientEmail = isSuperAdmin ? selectedClientEmail : auth?.user?.email;
		
// 		if (clientEmail) {
// 			checkClientProducts({ client_email: clientEmail });
// 		}
// 	};

// 	const clients = clientsData?.data || [];

// 	// Show loading state while fetching clients for super admin
// 	if (isSuperAdmin && isLoadingClients) {
// 		return (
// 			<div className="flex items-center justify-center p-12">
// 				<div className="text-center">
// 					<ClipLoader color="primary" size={50} />
// 					<p className="mt-4 text-gray-600">Loading clients...</p>
// 				</div>
// 			</div>
// 		);
// 	}

// 	return (
// 		<div>
// 			<div>
// 				{/* Client Selection for SUPER_ADMIN */}
// 				{isSuperAdmin && (
// 					<div className="mb-6">
// 						<label className="block text-sm font-medium mb-2">
// 							Select Client
// 						</label>
// 						<Select
// 							value={selectedClientEmail}
// 							onValueChange={handleClientSelect}
// 						>
// 							<SelectTrigger className="w-full max-w-md">
// 								<SelectValue placeholder="Select a client to view products" />
// 							</SelectTrigger>
// 							<SelectContent>
// 								{clients.length > 0 ? (
// 									clients.map((client) => (
// 										<SelectItem
// 											key={client.id}
// 											value={client.email}
// 										>
// 											{client.company_name || client.email}
// 										</SelectItem>
// 									))
// 								) : (
// 									<SelectItem value="no-clients" disabled>
// 										No clients available
// 									</SelectItem>
// 								)}
// 							</SelectContent>
// 						</Select>
// 					</div>
// 				)}

// 				<div className="relative">
// 					{isLoadingProducts ? (
// 						<div className="p-[40px] h-[20vh] place-content-center text-center z-50">
// 							<ClipLoader color="primary" size={35} />
// 							<p>Loading products</p>
// 						</div>
// 					) : (
// 						<section className="mt-8">
// 							<Table>
// 								<TableHeader>
// 									<TableRow>
// 										<TableHead>Product Description</TableHead>
// 										<TableHead>Product Name</TableHead>
// 										<TableHead>GTIN</TableHead>
// 										<TableHead>Action</TableHead>
// 									</TableRow>
// 								</TableHeader>
// 								<TableBody>
// 									{clientProducts?.length > 0 ? (
// 										clientProducts.map((product, i) => (
// 											<TableRow key={product.gtin || i}>
// 												<TableCell>
// 													{product.description}
// 												</TableCell>
// 												<TableCell>
// 													{product.prod_name}
// 												</TableCell>
// 												<TableCell>
// 													{product.gtin}
// 												</TableCell>
// 												<TableCell>
// 													<button
// 														onClick={() => handleOpen(product)}
// 														className="flex items-center gap-1 text-primary hover:underline"
// 													>
// 														<AiOutlineEdit /> edit
// 													</button>
// 												</TableCell>
// 											</TableRow>
// 										))
// 									) : (
// 										<TableRow>
// 											<TableCell colSpan={4}>
// 												<h1 className="text-center h-[20vh] place-content-center text-gray-500">
// 													{isSuperAdmin && clients.length === 0
// 														? "No clients available"
// 														: "NO PRODUCTS FOUND"}
// 												</h1>
// 											</TableCell>
// 										</TableRow>
// 									)}
// 								</TableBody>
// 							</Table>
// 						</section>
// 					)}
// 				</div>
// 			</div>

// 			<Dialog open={open} onOpenChange={setOpen}>
// 				<DialogContent className="max-w-xl">
// 					<DialogHeader>
// 						<DialogDescription>
// 							<ProductForm
// 								clientProduct={localProduct}
// 								isOnboarding={false}
// 								onComplete={handleComplete}
// 							/>
// 						</DialogDescription>
// 					</DialogHeader>
// 				</DialogContent>
// 			</Dialog>
// 		</div>
// 	);
// }

// export default ClientProducts;





// import React, { useState, useEffect } from "react";
// import {
// 	Table,
// 	TableBody,
// 	TableCell,
// 	TableHead,
// 	TableHeader,
// 	TableRow,
// } from "../components/ui/table";
// import { useNavigate } from "react-router-dom";
// import { useToast } from "../components/ui/use-toast";
// import { ClipLoader } from "react-spinners";
// import {
// 	Dialog,
// 	DialogContent,
// 	DialogDescription,
// 	DialogHeader,
// } from "../components/ui/dialog";
// import {
// 	Select,
// 	SelectContent,
// 	SelectItem,
// 	SelectTrigger,
// 	SelectValue,
// } from "../components/ui/select";
// import ProductForm from "../components/ProductForm";
// import { AiOutlineEdit } from "react-icons/ai";
// import useAuth from "../hooks/useAuth";
// import { useGetAllClients, useGetClientProducts } from "../migration-api/api-hooks/clients";

// function ClientProducts() {
// 	const [open, setOpen] = useState(false);
// 	const navigate = useNavigate();
// 	const { auth } = useAuth();
// 	const { toast } = useToast();

// 	const [clientProducts, setClientProducts] = useState([]);
// 	const [localProduct, setLocalProduct] = useState(null);
// 	const [selectedClientId, setSelectedClientId] = useState("");

// 	const isSuperAdmin = auth?.user?.role === "SUPER_ADMIN";
//   	const isAdmin = auth?.user?.role !== "SUPER_ADMIN";
// 	const clientId = auth?.user?.clientId;


// 	// Fetch all clients for super admin
// 	const { data: clientsData, isLoading: isLoadingClients } = useGetAllClients({}, {
// 		enabled: isSuperAdmin,
// 		onError: (error) => {
// 			toast({
// 				variant: "destructive",
// 				title: "Error",
// 				description: "Failed to fetch clients",
// 			});
// 		},
// 	});

// 	// Use the custom hook for checking client products
// 	const { data: productsData, isLoading: isLoadingProducts, refetch: refetchProducts } = useGetClientProducts(
// 		isAdmin ? clientId : selectedClientId,
// 		{
// 			enabled: (isAdmin && !!clientId) || (isSuperAdmin && !!selectedClientId),
// 			onSuccess: (data) => {
// 				const products = data?.data || [];
// 				setClientProducts(products);

// 				if (products.length === 0) {
// 					toast({
// 						title: "No Products Found",
// 						description: "This client has no products available.",
// 					});
// 				}
// 			},
// 			onError: (error) => {
// 				// Clear the products when error occurs
// 				setClientProducts([]);

// 				if (error.code === "ERR_NETWORK") {
// 					navigate("/", { replace: true });
// 				} else if (
// 					error.response?.status === 401 ||
// 					error.response?.status === 403
// 				) {
// 					navigate("/", { replace: true });
// 				} else {
// 					toast({
// 						variant: "destructive",
// 						title: "Error",
// 						description:
// 							error?.response?.data?.message || "Failed to fetch products",
// 					});
// 				}
// 			},
// 		}
// 	);

// 	const isLoading = isSuperAdmin ? isLoadingClients : isLoadingProducts;

// 	// Auto-select first client for SUPER_ADMIN when clients are loaded
// 	useEffect(() => {
// 		const clients = clientsData?.data || [];
// 		if (isSuperAdmin && clients.length > 0 && !selectedClientId) {
// 			const firstClient = clients[0];
// 			setSelectedClientId(firstClient.id);
// 		}
// 	}, [isSuperAdmin, clientsData, selectedClientId]);

// 	// Handle client selection for SUPER_ADMIN
// 	const handleClientSelect = (clientId) => {
// 		setSelectedClientId(clientId);
// 		setClientProducts([]); // Clear previous products
// 	};

// 	// Refetch when selectedClientId changes
// 	useEffect(() => {
// 		if (selectedClientId) {
// 			refetchProducts();
// 		}
// 	}, [selectedClientId, refetchProducts]);

// 	// Handle opening edit dialog
// 	const handleOpen = (productData) => {
// 		setOpen(true);
// 		const currentClientId = isSuperAdmin ? selectedClientId : clientId;
		
// 		setLocalProduct({
// 			...productData,
// 			client_id: currentClientId,
// 			description: productData?.descriptions,
// 			prod_name: productData?.prodName,
// 			gtin: productData?.gtin,
// 			nafdac_reg_no: productData?.nafdacRegNo,
// 			is_nafdac: productData?.isNafdac,
// 		});
// 	};

// 	// Refresh products after update
// 	const handleComplete = () => {
// 		setOpen(false);
// 		refetchProducts();
// 	};

// 	const clients = clientsData?.data || [];

// 	// Show loading state while fetching clients for super admin
// 	if (isSuperAdmin && isLoadingClients) {
// 		return (
// 			<div className="flex items-center justify-center p-12">
// 				<div className="text-center">
// 					<ClipLoader color="primary" size={50} />
// 					<p className="mt-4 text-gray-600">Loading clients...</p>
// 				</div>
// 			</div>
// 		);
// 	}

// 	return (
// 		<div>
// 			<div>
// 				{/* Client Selection for SUPER_ADMIN */}
// 				{isSuperAdmin && (
// 					<div className="mb-6">
// 						<label className="block text-sm font-medium mb-2">
// 							Select Client
// 						</label>
// 						<Select
// 							value={selectedClientId}
// 							onValueChange={handleClientSelect}
// 						>
// 							<SelectTrigger className="w-full max-w-md">
// 								<SelectValue placeholder="Select a client to view products" />
// 							</SelectTrigger>
// 							<SelectContent>
// 								{clients.length > 0 ? (
// 									clients.map((client) => (
// 										<SelectItem
// 											key={client.id}
// 											value={client.id}
// 										>
// 											{client.company_name || client.email}
// 										</SelectItem>
// 									))
// 								) : (
// 									<SelectItem value="no-clients" disabled>
// 										No clients available
// 									</SelectItem>
// 								)}
// 							</SelectContent>
// 						</Select>
// 					</div>
// 				)}

// 				<div className="relative">
// 					{isLoading ? (
// 						<div className="p-[40px] h-[20vh] place-content-center text-center z-50">
// 							<ClipLoader color="primary" size={35} />
// 							<p>Loading products</p>
// 						</div>
// 					) : (
// 						<section className="mt-8">
// 							<Table>
// 								<TableHeader>
// 									<TableRow>
// 										<TableHead>Product Description</TableHead>
// 										<TableHead>Product Name</TableHead>
// 										<TableHead>GTIN</TableHead>
// 										<TableHead>Action</TableHead>
// 									</TableRow>
// 								</TableHeader>
// 								<TableBody>
// 									{isLoading && (
// 										<TableRow>
// 											<TableCell colSpan={5}>
// 												<div className="h-[20vh] place-content-center text-center">
// 													<ClipLoader />
// 												</div>
// 											</TableCell>
// 										</TableRow>
// 									)}
// 									{clientProducts?.length > 0 ? (
// 										clientProducts.map((product, i) => (
// 											<TableRow key={product.gtin || i}>
// 												<TableCell>
// 													{product.descriptions}
// 												</TableCell>
// 												<TableCell>
// 													{product.prodName}
// 												</TableCell>
// 												<TableCell>
// 													{product.gtin}
// 												</TableCell>
// 												<TableCell>
// 													<button
// 														onClick={() => handleOpen(product)}
// 														className="flex items-center gap-1 text-primary hover:underline"
// 													>
// 														<AiOutlineEdit /> edit
// 													</button>
// 												</TableCell>
// 											</TableRow>
// 										))
// 									) : (
// 										<TableRow>
// 											<TableCell colSpan={4}>
// 												<h1 className="text-center h-[20vh] place-content-center text-gray-500">
// 													{!isLoading && isSuperAdmin && clients.length === 0
// 														? "No clients available"
// 														: "NO PRODUCTS FOUND"}
// 												</h1>
// 											</TableCell>
// 										</TableRow>
// 									)}
// 								</TableBody>
// 							</Table>
// 						</section>
// 					)}
// 				</div>
// 			</div>

// 			<Dialog open={open} onOpenChange={setOpen}>
// 				<DialogContent className="max-w-xl">
// 					<DialogHeader>
// 						<DialogDescription>
// 							<ProductForm
// 								clientProduct={localProduct}
// 								isOnboarding={false}
// 								onComplete={handleComplete}
// 							/>
// 						</DialogDescription>
// 					</DialogHeader>
// 				</DialogContent>
// 			</Dialog>
// 		</div>
// 	);
// }

// export default ClientProducts;





import React, { useState, useEffect } from "react";
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "../components/ui/table";
import { useNavigate } from "react-router-dom";
import { useToast } from "../components/ui/use-toast";
import { ClipLoader } from "react-spinners";
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogHeader,
} from "../components/ui/dialog";
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "../components/ui/select";
import ProductForm from "../components/ProductForm";
import { AiOutlineEdit } from "react-icons/ai";
import useAuth from "../hooks/useAuth";
import { useGetAllClients, useGetClientProducts } from "../migration-api/api-hooks/clients";

function ClientProducts() {
	const [open, setOpen] = useState(false);
	const navigate = useNavigate();
	const { auth } = useAuth();
	const { toast } = useToast();

	const [clientProducts, setClientProducts] = useState([]);
	const [localProduct, setLocalProduct] = useState(null);
	const [selectedClientId, setSelectedClientId] = useState("");
	const [isInitialLoad, setIsInitialLoad] = useState(true);

	const isSuperAdmin = auth?.user?.role === "SUPER_ADMIN";
  	const isAdmin = auth?.user?.role !== "SUPER_ADMIN";
	const clientId = auth?.user?.clientId;


	// Fetch all clients for super admin
	const { data: clientsData, isLoading: isLoadingClients } = useGetAllClients({}, {
		enabled: isSuperAdmin,
		onError: (error) => {
			toast({
				variant: "destructive",
				title: "Error",
				description: "Failed to fetch clients",
			});
		},
	});

	// Use the custom hook for checking client products
	const { data: productsData, isLoading: isLoadingProducts, isFetching: isFetchingProducts, refetch: refetchProducts } = useGetClientProducts(
		isAdmin ? clientId : selectedClientId,
		{
			enabled: (isAdmin && !!clientId) || (isSuperAdmin && !!selectedClientId),
			onSuccess: (data) => {
				const products = data?.data || [];
				setClientProducts(products);
				setIsInitialLoad(false);

				if (products.length === 0) {
					toast({
						title: "No Products Found",
						description: "This client has no products available.",
					});
				}
			},
			onError: (error) => {
				// Clear the products when error occurs
				setClientProducts([]);
				setIsInitialLoad(false);

				if (error.code === "ERR_NETWORK") {
					navigate("/", { replace: true });
				} else if (
					error.response?.status === 401 ||
					error.response?.status === 403
				) {
					navigate("/", { replace: true });
				} else {
					toast({
						variant: "destructive",
						title: "Error",
						description:
							error?.response?.data?.message || "Failed to fetch products",
					});
				}
			},
		}
	);

	// Auto-select first client for SUPER_ADMIN when clients are loaded
	useEffect(() => {
		const clients = clientsData?.data || [];
		if (isSuperAdmin && clients.length > 0 && !selectedClientId) {
			const firstClient = clients[0];
			setSelectedClientId(firstClient.id);
		}
	}, [isSuperAdmin, clientsData, selectedClientId]);

	// Handle client selection for SUPER_ADMIN
	const handleClientSelect = (clientId) => {
		setSelectedClientId(clientId);
		setClientProducts([]); // Clear previous products
		setIsInitialLoad(true); // Set loading state for new client
	};

	// Refetch when selectedClientId changes
	useEffect(() => {
		if (selectedClientId) {
			refetchProducts();
		}
	}, [selectedClientId, refetchProducts]);

	// Handle opening edit dialog
	const handleOpen = (productData) => {
		setOpen(true);
		const currentClientId = isSuperAdmin ? selectedClientId : clientId;
		
		setLocalProduct({
			...productData,
			client_id: currentClientId,
			description: productData?.descriptions,
			prod_name: productData?.prodName,
			gtin: productData?.gtin,
			nafdac_reg_no: productData?.nafdacRegNo,
			is_nafdac: productData?.isNafdac,
		});
	};

	// Refresh products after update
	const handleComplete = () => {
		setOpen(false);
		refetchProducts();
	};

	const clients = clientsData?.data || [];

	// Comprehensive loading state that handles all scenarios
	const showLoading = 
		isLoadingClients || 
		isLoadingProducts || 
		isFetchingProducts || 
		isInitialLoad ||
		(isSuperAdmin && !selectedClientId) ||
		(isAdmin && !clientId);

	// Show loading state while fetching clients for super admin
	if (isSuperAdmin && isLoadingClients) {
		return (
			<div className="flex items-center justify-center p-12">
				<div className="text-center">
					<ClipLoader color="primary" size={50} />
					<p className="mt-4 text-gray-600">Loading clients...</p>
				</div>
			</div>
		);
	}

	return (
		<div>
			<div>
				{/* Client Selection for SUPER_ADMIN */}
				{isSuperAdmin && (
					<div className="mb-6">
						<label className="block text-sm font-medium mb-2">
							Select Client
						</label>
						<Select
							value={selectedClientId}
							onValueChange={handleClientSelect}
						>
							<SelectTrigger className="w-full max-w-md">
								<SelectValue placeholder="Select a client to view products" />
							</SelectTrigger>
							<SelectContent>
								{clients.length > 0 ? (
									clients.map((client) => (
										<SelectItem
											key={client.id}
											value={client.id}
										>
											{client.company_name || client.email}
										</SelectItem>
									))
								) : (
									<SelectItem value="no-clients" disabled>
										No clients available
									</SelectItem>
								)}
							</SelectContent>
						</Select>
					</div>
				)}

				<div className="relative">
					{showLoading ? (
						<div className="p-[40px] h-[20vh] place-content-center text-center z-50">
							<ClipLoader color="primary" size={35} />
							<p>Loading products</p>
						</div>
					) : (
						<section className="mt-8">
							<Table>
								<TableHeader>
									<TableRow>
										<TableHead>Product Description</TableHead>
										<TableHead>Product Name</TableHead>
										<TableHead>GTIN</TableHead>
										<TableHead>Action</TableHead>
									</TableRow>
								</TableHeader>
								<TableBody>
									{clientProducts?.length > 0 ? (
										clientProducts.map((product, i) => (
											<TableRow key={product.gtin || i}>
												<TableCell>
													{product.descriptions}
												</TableCell>
												<TableCell>
													{product.prodName}
												</TableCell>
												<TableCell>
													{product.gtin}
												</TableCell>
												<TableCell>
													<button
														onClick={() => handleOpen(product)}
														className="flex items-center gap-1 text-primary hover:underline"
													>
														<AiOutlineEdit /> edit
													</button>
												</TableCell>
											</TableRow>
										))
									) : (
										<TableRow>
											<TableCell colSpan={4}>
												<h1 className="text-center h-[20vh] place-content-center text-gray-500">
													{isSuperAdmin && clients.length === 0
														? "No clients available"
														: "NO PRODUCTS FOUND"}
												</h1>
											</TableCell>
										</TableRow>
									)}
								</TableBody>
							</Table>
						</section>
					)}
				</div>
			</div>

			<Dialog open={open} onOpenChange={setOpen}>
				<DialogContent className="max-w-xl">
					<DialogHeader>
						<DialogDescription>
							<ProductForm
								clientProduct={localProduct}
								isOnboarding={false}
								onComplete={handleComplete}
							/>
						</DialogDescription>
					</DialogHeader>
				</DialogContent>
			</Dialog>
		</div>
	);
}

export default ClientProducts;